import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all prompts
export const getPrompts = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/prompts`);
    return response.data;
  } catch (error) {
    console.error("Error fetching prompts:", error.response?.data || error);
    throw error;
  }
};

// GET a single prompts
export const getPromptsById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/prompts/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching prompts:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new prompts
export const createPrompts = async (promptsData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/prompts`, promptsData);
    return response.data;
  } catch (error) {
    console.error("Error creating prompts:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing prompts
export const updatePrompts = async (id, promptsData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/prompts/${id}`, promptsData);
    return response.data;
  } catch (error) {
    console.error("Error updating prompts:", error.response?.data || error);
    throw error;
  }
};

// DELETE a prompts
export const deletePrompts = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/prompts/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting prompts:", error.response?.data || error);
    throw error;
  }
};
